import { render, staticRenderFns } from "./GeneralSettingContactAddressCompanyId.vue?vue&type=template&id=05d23f4e&"
import script from "./GeneralSettingContactAddressCompanyId.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddressCompanyId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports